import { Grid, IconButton, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import AutoCompleteSelect from '../AutoComplete/AutoCompleteSelect';
import { SUPPORTING_LINKS } from '../../constants';
import { ExternalLinkType } from '../../enums';

const defaultLink = {
  linkType: ExternalLinkType.None,
  url: '',
};
const SupportingLinks = () => {
  // ## Form Data .....
  const {
    register,
    getValues,
    setValue,
    formState: { errors },
  } = useFormContext();

  // ## Variables .....
  const supportingLinks = useFieldArray({ name: 'supportingLinks' });
  const [inputCounter, setInputCounter] = useState(1);

  // ## Functions/Methods .....
  const handleClick = (deleteIndex = -1) => {
    if (deleteIndex >= 0) {
      //remove the item from the request object and update the request object
      const tmpData = getValues('supportingLinks');
      tmpData.splice(deleteIndex, 1);
      setValue('supportingLinks', tmpData);
      setInputCounter(inputCounter - 1);
      // supportingLinks.remove(deleteIndex);
    } else {
      setInputCounter(inputCounter + 1);
      supportingLinks.append(defaultLink);
    }
  };

  const getDefaultLinkType = (type) => {
    const link = SUPPORTING_LINKS.find((l) => l.name === type);
    if (link) {
      return link;
    }
    return '';
  };

  // ## Hooks .....
  useEffect(() => {
    // console.log('supportingLinks', supportingLinks);
    const links = getValues('supportingLinks');
    supportingLinks.append(defaultLink);
  }, []);

  return (
    <>
      <Grid container spacing={1}>
        {supportingLinks.fields.map((link, index) => {
          return (
            <>
              {/* ## => Select Input <= ## */}
              <Grid item xs={3}>
                <AutoCompleteSelect
                  id={`link-type-select-${index}`}
                  items={SUPPORTING_LINKS}
                  itemText="label"
                  itemKey="name"
                  labelText="Link Type"
                  placeHolderText="Select Link Type"
                  multiSelect={false}
                  labelPaddingTop="-5px"
                  defaultValue={getDefaultLinkType(getValues(`supportingLinks[${index}].linkType`)) ?? ''}
                  onChange={(value) => setValue(`supportingLinks[${index}].linkType`, value.name)}
                  limitTags={5}
                />
              </Grid>

              {/* ## => URL <= ## */}
              <Grid item xs={9} sx={{ display: 'flex' }}>
                <TextField
                  type="text"
                  {...register(`supportingLinks[${index}].url`)}
                  name={`supportingLinks[${index}].url`}
                  label="URL"
                  placeholder="URL"
                  fullWidth
                  size="small"
                  //   inputProps={{ maxLength: 50 }}
                  // error={
                  //   getValues('errors') &&
                  //   getValues('errors').has &&
                  //   getValues('errors').has(`surveyResponse.suggestedInputs[${index}].name`)
                  // }
                />
                {index + 1 === supportingLinks.fields.length && (
                  <IconButton
                    color="primary"
                    aria-label="add"
                    size="large"
                    disabled={getValues('mode') === 'view'}
                    onClick={() => handleClick()}
                    sx={{ marginTop: '-5px' }}
                  >
                    <AddIcon />
                  </IconButton>
                )}
                {index + 1 !== supportingLinks.fields.length && (
                  <IconButton
                    color="error"
                    aria-label="delete"
                    size="large"
                    disabled={getValues('mode') === 'view'}
                    onClick={() => handleClick(index)}
                    sx={{ marginTop: '-5px' }}
                  >
                    <DeleteIcon />
                  </IconButton>
                )}
              </Grid>
            </>
          );
        })}
      </Grid>
    </>
  );
};

export default SupportingLinks;
